import { B2C_ACCOUNT_PROFILE_PATH } from '../../constants/links';
import { apiB2C } from '../axios-client';
export const b2cAccountApi = {
    profileDetails: () => apiB2C.get(B2C_ACCOUNT_PROFILE_PATH),
    updateProfileDetails: (requestData, token) => {
        return apiB2C.put(B2C_ACCOUNT_PROFILE_PATH, requestData, {
            headers: { 'google-auth': token || '' },
        });
    },
};
